import { Component, createElement } from 'react';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';

export default class Link extends Component {
  static propTypes = {
    external: PropTypes.bool,
    to: PropTypes.any
  };

  render() {
    const { external, to, ...rest } = this.props;
    let element;
    let nextProps;

    if (external) {
      element = 'a';
      nextProps = { href: to, ...rest };
    } else {
      element = RouterLink;
      nextProps = { to, ...rest };
    }

    return createElement(element, nextProps);
  }
}



// WEBPACK FOOTER //
// ./src/atoms/Link/Link/index.js